import * as React from 'react'
import './toggleon.css'

export const ToggleOn = (props: any) =>
<svg id="Component_90_1" data-name="Component 90 – 1" xmlns="http://www.w3.org/2000/svg" width="54" height="29" viewBox="0 0 54 29">
  <rect id="Rectangle_1674" data-name="Rectangle 1674" className="on-1" width="54" height="29" rx="14.5"/>
  <circle id="Ellipse_108" data-name="Ellipse 108" className="on-2" cx="9.5" cy="9.5" r="9.5" transform="translate(29 5)"/>
</svg>
